import { SendEncryptedXmlOfferCommand } from './SendEncryptedXmlOfferCommand'
import { ProcedureId, SingleProcedureRepository } from '@/Domain/Procedures'
import { AccountId } from '@/Domain/Account'
import { UserName } from '@/Domain/XmlOffer'
import {
  EncryptedXmlOffer,
  XmlOfferEncrypterService,
  EncryptedXmlOfferRepository
} from '@/Domain/XmlOffer/Encrypter'
import { XmlOfferBuilderService } from '@/Domain/XmlOffer/Builder'
import { SendEncryptedOfferResponseDto } from './SendEncryptedOfferResponseDto'
import { XmlInfoDto } from './XmlInfoDto'
import { ConcatenatedBatches } from '@/Domain/AuctionA'

export class SendEncryptedXmlOfferCommandHandler {
  private _xmlOfferBuilderService: XmlOfferBuilderService
  private _xmlOfferEncrypterService: XmlOfferEncrypterService
  private _xmlOfferEncryptedRepository: EncryptedXmlOfferRepository
  private _procedureRepository: SingleProcedureRepository
  constructor (
    xmlOfferBuilderService: XmlOfferBuilderService,
    xmlOfferEncrypterService: XmlOfferEncrypterService,
    xmlOfferEncryptedRepository: EncryptedXmlOfferRepository,
    procedureRepository: SingleProcedureRepository
  ) {
    this._xmlOfferBuilderService = xmlOfferBuilderService
    this._xmlOfferEncrypterService = xmlOfferEncrypterService
    this._xmlOfferEncryptedRepository = xmlOfferEncryptedRepository
    this._procedureRepository = procedureRepository
  }

  async handle (command: SendEncryptedXmlOfferCommand): Promise<SendEncryptedOfferResponseDto> {
    try {
      const procedureId = new ProcedureId(command.procedureId())
      const procedure = await this._procedureRepository.byId(procedureId)
      const accountId = new AccountId(command.userId())
      const userName = new UserName(command.userName())
      const concatenatedBatches = new ConcatenatedBatches(command.concatenatedBatches())
      const xmlOffers = await this._xmlOfferBuilderService.buildXmls(procedureId, accountId, userName)
      const xmlInfoDto: XmlInfoDto[] = []
      const encryptedOffers: EncryptedXmlOffer[] = []
      for (const singleXmlOffer of xmlOffers) {
        const encryptedOffer = await this._xmlOfferEncrypterService.encrypt(singleXmlOffer, procedure.province())
        encryptedOffers.push(encryptedOffer)
        xmlInfoDto.push(new XmlInfoDto(
          encryptedOffer.md5Hash(),
          encryptedOffer.batchId(),
          singleXmlOffer.xmlString()
        ))
      }
      const responseUrl = await this._xmlOfferEncryptedRepository.store(
        procedureId,
        accountId,
        concatenatedBatches,
        encryptedOffers
      )
      return new SendEncryptedOfferResponseDto(
        responseUrl,
        xmlInfoDto
      )
    } catch (error) {
      return Promise.reject(error)
    }
  }
}
